import { render, staticRenderFns } from "./targetBoard.vue?vue&type=template&id=f41d12b2&scoped=true"
import script from "./targetBoard.vue?vue&type=script&lang=js"
export * from "./targetBoard.vue?vue&type=script&lang=js"
import style0 from "./targetBoard.vue?vue&type=style&index=0&id=f41d12b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41d12b2",
  null
  
)

export default component.exports